export function stringIsNotNullUndefinedOrEmpty(
    str: string | null | undefined
): str is string {
    return !!(str && str.trim().length > 0);
}
